import { useState } from 'react'
import { createRestClient } from '@/contexts/QueryProvider'
import { DataGridComponent } from '../DataGrid/DataGridComponent'
import { ErrorComponent } from '../ErrorComponent/ErrorComponent'
import { ApplicationTeamForm } from '../Forms/ApplicationTeamForm'
import { Loading } from '../Loading'
import { OverlayDrawerComponent } from '../OverlayDrawerComponent/OverlayDrawerComponent'
import { appTeamsTableColumns } from './appTeamTableColumns/appTeamsTableColumns'
import { MessagesApplicationsApplicationTeam } from '@/dotnet-client'

type AppTeamsPanelProps = {
  appId: number
}

export const AppTeamsPanel = ({ appId }: AppTeamsPanelProps) => {
  const { getApplicationsApiGetApplicationTeamsForUserOrganization } = createRestClient()

  const {
    data: applicationTeams,
    isPending,
    isError,
  } = getApplicationsApiGetApplicationTeamsForUserOrganization.useQuery<MessagesApplicationsApplicationTeam[]>({
    path: { appId },
  })

  const [addApplicationTeam, setAddApplicationTeam] = useState<boolean>(false)

  if (isPending) {
    return <Loading />
  }
  if (isError) {
    return <ErrorComponent />
  }

  return (
    <div className="container">
      <DataGridComponent
        items={applicationTeams}
        columns={appTeamsTableColumns}
        heightAdjustment={180}
        onAdd={() => setAddApplicationTeam(true)}
      />
      <OverlayDrawerComponent
        key="addform"
        open={addApplicationTeam}
        size="medium"
        setOpen={setAddApplicationTeam}
        title={'Add support team'}
        content={<ApplicationTeamForm applicationId={appId} onSubmit={() => setAddApplicationTeam(false)} />}
      />
    </div>
  )
}
